import RoomSearchCriteria, { GuestType } from "./RoomSearchCriteria";

class RoomSearchFormState {
    numberOfRooms: number = 1;
    guestType: GuestType;
    checkInDate: string;
    checkOutDate: string;    
    
    isValid() {
        return this.checkInDate != null && this.checkOutDate != null && this.numberOfRooms > 0 && this.guestType != null;        
    }

    toRoomSearchCriteria():RoomSearchCriteria {
        return new RoomSearchCriteria(this.checkInDate, this.checkOutDate, this.numberOfRooms, this.guestType); 
    }
}

export default RoomSearchFormState;